// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37965bcd","455":"244a880d","977":"489d41d6"}[chunkId] + ".chunk.js";
};